// This file provides the base DataClass for other classes to extend
// Other classes import this as DataObject for backward compatibility
import DataClass from './DataClass';

export default DataClass;